import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiSend } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import './CommentsSection.css';

const CommentsSection = ({ webinarId }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newComment, setNewComment] = useState({ author_name: '', email: '', text: '' });
  const { isModerator } = useAuth();

  useEffect(() => {
    fetchComments();
  }, [webinarId]);

  const fetchComments = async () => {
    try {
      const response = await axios.get(`/api/webinars/${webinarId}/`);
      setComments(response.data.comments || []);
    } catch (error) {
      console.error('Error fetching comments:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.text.trim()) {
      toast.error('Введите текст комментария');
      return;
    }

    try {
      await axios.post(`/api/webinars/${webinarId}/comments/`, newComment);
      toast.success('Комментарий добавлен');
      setNewComment({ author_name: '', email: '', text: '' });
      fetchComments();
    } catch (error) {
      toast.error('Ошибка добавления комментария');
    }
  };

  const handleDelete = async (commentId) => {
    if (!isModerator) {
      return;
    }
    if (!window.confirm('Удалить этот комментарий?')) {
      return;
    }
    try {
      await axios.delete(`/api/webinars/${webinarId}/comments/${commentId}/`);
      toast.success('Комментарий удалён');
      fetchComments();
    } catch (error) {
      toast.error('Ошибка удаления комментария');
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="comments-section" id="comments-section">
      <h3>Комментарии ({comments.length})</h3>
      
      <form onSubmit={handleSubmit} className="comment-form">
        <div className="form-row">
          <input
            type="text"
            className="form-input"
            placeholder="Ваше имя"
            value={newComment.author_name}
            onChange={(e) => setNewComment({ ...newComment, author_name: e.target.value })}
          />
          <input
            type="email"
            className="form-input"
            placeholder="Email (опционально)"
            value={newComment.email}
            onChange={(e) => setNewComment({ ...newComment, email: e.target.value })}
          />
        </div>
        <div className="form-row">
          <textarea
            className="form-textarea"
            placeholder="Ваш комментарий"
            value={newComment.text}
            onChange={(e) => setNewComment({ ...newComment, text: e.target.value })}
            rows="3"
          />
          <button type="submit" className="btn btn-primary btn-small">
            <FiSend /> Отправить
          </button>
        </div>
      </form>

      <div className="comments-list">
        {comments.length > 0 ? (
          comments.map((comment) => (
            <div key={comment.id} className="comment-item">
              <div className="comment-header">
                <strong>{comment.author_name}</strong>
                <span className="comment-date">
                  {new Date(comment.created_at).toLocaleDateString('ru-RU')}
                </span>
                {isModerator && (
                  <button
                    type="button"
                    className="comment-delete-btn"
                    onClick={() => handleDelete(comment.id)}
                    title="Удалить комментарий"
                  >
                    ×
                  </button>
                )}
              </div>
              <p className="comment-text">{comment.text}</p>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <p>Пока нет комментариев</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentsSection;
